const headerMenuItems = document.querySelectorAll('.header__inline-menu header-menu');
const navBorder = document.getElementById('ap-nav-tab');
const navList = document.querySelector('ul.list-menu--inline');

headerMenuItems.forEach((item) => {
  item.addEventListener('mouseenter', () => {
    const trigger = item.querySelector('[aria-expanded]');
    if (trigger && navList) {
      const triggerRect = trigger.getBoundingClientRect();
      const navRect = navList.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const offsetLeft = itemRect.left - navRect.left;
      const paddingLeft = parseFloat(window.getComputedStyle(item).paddingLeft) || 0;
      const offsetPercentage = (offsetLeft / navRect.width) * 100 + (paddingLeft / navRect.width) * 100;
      navBorder.style.left = offsetPercentage + '%';
      navBorder.style.width = triggerRect.width + 'px';
    }
  });

  item.addEventListener('mouseleave', () => {
    navBorder.style.width = '0px';
  });
});

// Mobile drawer menu toggles
document.querySelectorAll('.weezie-mobile__header-top-menu').forEach((parentDetails) => {
  parentDetails.addEventListener('click', function (event) {
    event.stopPropagation();
    document.querySelectorAll('.weezie-mobile__header-top-menu').forEach((otherDetails) => {
      if (otherDetails !== this) {
        otherDetails.removeAttribute('open');
      }
    });
  });
});

document.querySelectorAll('.weezie-menu-drawer__menu').forEach((childDetails) => {
  childDetails.addEventListener('click', function (event) {
    event.stopPropagation();
    this.closest('.weezie-mobile__header-top-menu')
      .querySelectorAll('.weezie-menu-drawer__menu')
      .forEach((otherChild) => {
        if (otherChild !== this) {
          otherChild.removeAttribute('open');
        }
      });
  });
});

// Header logo scroll animation
const logoWrapper = document.querySelector('.header__heading-logo-wrapper');

if (logoWrapper) {
  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY) {
      logoWrapper.classList.add('scrolled');
    } else if (currentScrollY < lastScrollY) {
      logoWrapper.classList.remove('scrolled');
    }

    lastScrollY = currentScrollY;
  });
}

